import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOnboardingSettingsSaveMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  parseOnboardingProcessEntity,
  parseOnboardingSettingsSaveParam,
} from '../helpers';

export const useOnboardingSettingsSave = () => {
  const [handle, { data, loading, error: apolloError }] =
    useOnboardingSettingsSaveMutation();

  const error = useError(apolloError);

  const saveSettings = useCallback(
    async (id: string, currentStepName: OnboardingProcessStepNameType) => {
      const input = parseOnboardingSettingsSaveParam(currentStepName);
      const res = await handle({
        variables: {
          id,
          input,
        },
      });
      return res.data?.onboardingSettingsSave?.process
        ? parseOnboardingProcessEntity(
            res.data?.onboardingSettingsSave?.process
          )
        : undefined;
    },
    [handle]
  );

  return {
    data,
    loading,
    error,
    saveSettings,
  };
};
